import { IMusimapCollectionGenericItem, IMusimapFilterCore } from './musimap-common.interface';
import { MUSIMAP_SELECTION_STATES } from './musimap-common.enum';
import { asArray } from '../../../abstract/shared';

const { NOT_SELECTED, INCLUDED_ALL } = MUSIMAP_SELECTION_STATES;

export const getItemsDividedByCategories = (
  items: IMusimapCollectionGenericItem[]
): {
  includedItems: IMusimapCollectionGenericItem[];
  excludedItems: IMusimapCollectionGenericItem[];
} => {
  return items.reduce(
    (agg, item) => {
      const { value, preference } = item;
      const hasValue = value !== NOT_SELECTED;
      const hasPreference = preference !== NOT_SELECTED;
      const useValue = hasValue ? value : hasPreference ? preference : null;

      if (useValue) {
        if (useValue === INCLUDED_ALL) {
          agg.includedItems.push(item);
        } else {
          agg.excludedItems.push(item);
        }
      }

      return agg;
    },
    {
      includedItems: [],
      excludedItems: [],
    }
  );
};

export const getTagsFilterStatus = (
  totalSize: number,
  includedItemsSize: number = 0,
  excludedItemsSize: number = 0
): string => {
  if (includedItemsSize && excludedItemsSize) {
    return MUSIMAP_SELECTION_STATES.MIXED;
  } else if (!includedItemsSize && !excludedItemsSize) {
    return MUSIMAP_SELECTION_STATES.NOT_SELECTED;
  } else if (includedItemsSize === totalSize) {
    return MUSIMAP_SELECTION_STATES.INCLUDED_ALL;
  } else if (excludedItemsSize === totalSize) {
    return MUSIMAP_SELECTION_STATES.EXCLUDED_ALL;
  } else if (includedItemsSize && !excludedItemsSize) {
    return MUSIMAP_SELECTION_STATES.INCLUDED_SOME;
  } else if (excludedItemsSize && !includedItemsSize) {
    return MUSIMAP_SELECTION_STATES.EXCLUDED_SOME;
  } else {
    return MUSIMAP_SELECTION_STATES.NOT_SELECTED;
  }
};

export const getStatusForItemsSlice = (
  items: IMusimapCollectionGenericItem | IMusimapCollectionGenericItem[]
): string => {
  const slice = asArray(items);
  const { includedItems, excludedItems } = getItemsDividedByCategories(slice);
  return getTagsFilterStatus(slice.length, includedItems.length, excludedItems.length);
};

export const getSourceValues = (d: IMusimapFilterCore): string[] | any => d?.values || d?.includeFilter?.values;

export function modifyItemName(label: string): string {
  switch (label) {
    case 'Version':
      return 'GLS Version';
    case 'GCDM Versions':
    case 'Gcdm Versions':
      return 'Recording Version';
    case 'Parental Warning Type':
      return 'Rating';
    case 'ROC':
      return 'ROC Override';
    default:
      return label;
  }
}

export * from '../../../abstract/shared';
